import { render, staticRenderFns } from "./ServiceManual.vue?vue&type=template&id=5ce48d60"
import script from "./ServiceManual.vue?vue&type=script&lang=js"
export * from "./ServiceManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports